import { z } from "zod"
import { isAddress, isEnsName } from "../address"

// Note: For full i18n, we'd need to create a way to load these messages via
// a translation function that works outside React components.
// For now, we're using a constants approach which can be replaced later.

export const ADDRESS_VALIDATION_MESSAGES = {
  couldNotResolveEns: "Could not resolve ENS name.",
  invalidAddressOrEns: "Please enter a valid address or ENS name.",
  cannotTransferToSelf: "You cannot transfer to your own address.",
}

export const addressSchema = z
  .object({
    // This can be either an address or an ENS name
    // If you want to make this required, you can chain this schema with .refine (see TransferFlow)
    identifier: z.string().optional(),

    // Resolved address if passed an ENS name
    resolvedAddress: z.string().nullable().optional(),

    // Whether we are currently resolving the address
    isResolving: z.boolean().optional(),

    // Used to validate that the recipient is not the same as the current connected address
    currentAddress: z.string().optional(),
  })
  .refine(({ resolvedAddress }) => resolvedAddress !== null, {
    message: ADDRESS_VALIDATION_MESSAGES.couldNotResolveEns,
    path: ["resolvedAddress"],
  })
  .refine(
    ({ resolvedAddress, identifier }) => {
      const address = resolvedAddress ?? identifier

      if (!address) {
        return true
      }

      return isAddress(address)
    },
    {
      message: ADDRESS_VALIDATION_MESSAGES.invalidAddressOrEns,
      path: ["resolvedAddress"],
    },
  )
  .refine(
    ({ resolvedAddress, identifier }) => {
      const address = resolvedAddress ?? identifier

      if (!address || isEnsName(address)) {
        return true
      }

      return isAddress(address)
    },
    {
      message: ADDRESS_VALIDATION_MESSAGES.invalidAddressOrEns,
      path: ["identifier"],
    },
  )
